'use client'

import { LuneTheme } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import CrownAgentsBank from '@public/images/logos/crown-agents-bank.png'
import IDEO from '@public/images/logos/ideo.png'
import MillerKnoll from '@public/images/logos/millerknoll.png'
import moomin from '@public/images/logos/moomin.png'
import Ovako from '@public/images/logos/ovako.png'
import Vestre from '@public/images/logos/vestre.png'

import LogosGrid from '@/components/LogosGrid'

const logos = [
    {
        name: 'IDEO',
        img: IDEO,
        width: 69.99,
        height: 16,
    },
    {
        name: 'Moomin',
        img: moomin,
        width: 58.66,
        height: 16,
    },
    {
        name: 'Crown Agents Bank',
        img: CrownAgentsBank,
        width: 111.5,
        height: 32,
    },
    {
        name: 'Ovako',
        img: Ovako,
        width: 71.06,
        height: 17,
    },
    {
        name: 'MillerKnoll',
        img: MillerKnoll,
        width: 88.125,
        height: 18,
    },
    {
        name: 'Vestre',
        img: Vestre,
        width: 64.74,
        height: 16,
    },
]

const FundClimateProjectsLogos = () => {
    const { palette } = LuneTheme
    return (
        <Box
            sx={{
                position: 'relative',
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: '-50%',
                    right: '-50%',
                    height: '1px',
                    backgroundColor: `${palette.Grey300}`,
                    mx: {
                        lg: 37,
                        xl: 37,
                    },
                },
            }}
        >
            <LogosGrid sx={{ pt: 6, pb: 6 }} logos={logos} />
        </Box>
    )
}

export default FundClimateProjectsLogos
